var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-billing"},[_c('ProfileSettingsCurrentSubscriptions',{attrs:{"upgrade-button-show":false},on:{"subscribe":_vm.subscribe}}),_c('ProfileBillingAvailableSubscriptions',{on:{"subscribe":_vm.subscribe}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }